export default Object.freeze({
  general: 'general',
  keyAchievement: 'keyAchievement',
  extraCurricular: 'extraCurricular',
  rolesAndResponsibilities: 'rolesAndResponsibilities',
})
